module.exports = __webpack_public_path__ + "img/download.79ac8285.png";